import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import jwt_decode from 'jwt-decode'
import { getStorage } from './utils/storage'
import store from './store'
import { login } from './store/modules/user'
import './i18n'
import './index.css';
import App from './App';

const accessToken = getStorage('accessToken')
if (accessToken && accessToken !== '') {
  store.dispatch(login(jwt_decode(accessToken)))
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>
);